import "./BannerForm.css";

import { Dispatch } from "react";

import { OrganisationPermissionConstants } from "../../../../../../constants";
import { ActionButtons, Column, ErrorBox, Row, SingleFileUpload } from "../../../../../../widget";
import { OrganisationFormChangedAction } from "../../models";
import { useBannerForm } from "./useBannerForm";

interface BannerFormProps {
  objectUuid: string;
  objectType: string;
  organisationDefaultBanner: string | null;
  dispatch: Dispatch<OrganisationFormChangedAction>;
}

export const BannerForm = ({
  objectUuid,
  objectType,
  organisationDefaultBanner,
  dispatch,
}: BannerFormProps): JSX.Element => {
  const {
    displayedBanner,
    bannerUploadRef,
    errors,
    isHandleSubmitLoading,
    setBanner,
    handleCancel,
    handleSubmit,
    hasPermission,
  } = useBannerForm(objectUuid, objectType, organisationDefaultBanner, dispatch);
  const canEditOrganisation = hasPermission(OrganisationPermissionConstants.WRITE_ORGANISATION);

  return (
    <>
      {errors && errors.length > 0 && (
        <Row spacingV="ml">
          <Column span={5}>
            <ErrorBox title="Please solve the below issues before saving" text={errors.map((error) => error.message)} />
          </Column>
        </Row>
      )}
      <form onSubmit={(e) => handleSubmit(e)} className="OrganisationBannerForm">
        <Row spacingV="2xl">
          <Column span={5}>
            <SingleFileUpload
              label="New Banner"
              ref={bannerUploadRef}
              maxFileSize={1}
              onChange={(f) => {
                setBanner(f);
              }}
              corners="rounded"
              disabled={!canEditOrganisation}
            />
          </Column>
        </Row>
        {displayedBanner && (
          <Row>
            <Column span={12}>
              <div className="BannerContainer">
                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                <label id="banner">Current banner</label>
                <img
                  key={displayedBanner}
                  aria-labelledby="icon"
                  className="OrganisationBanner"
                  src={displayedBanner}
                  alt="OrganisationIcon"
                />
              </div>
            </Column>
          </Row>
        )}

        {canEditOrganisation && (
          <Row>
            <Column span={5}>
              <ActionButtons onCancel={handleCancel} isLoading={isHandleSubmitLoading} corners="rounded" />
            </Column>
          </Row>
        )}
      </form>
    </>
  );
};
